module.exports = __webpack_public_path__ + "img/ef_detail_more_b_zd.f44d481f.png";